export const PROJECTS_ENDPOINT = '/api/Projects';
export const PROJECTS_TABLE_ENDPOINT = '/api/ProjectsTable';
export const PROJECT_TEMPLATES_ENDPOINT = '/api/ProjectTemplates';
export const ADMIN_SYNCS_ENDPOINT = '/api/Admin';
export const USERS_ENDPOINT = '/api/Users';
export const PROJECT_SECTIONS_ENDPOINT = '/api/ProjectSections'
